import React from 'react';

import { Box, Chip, Stack, Typography } from '@mui/material';
import { Link } from 'gatsby';

import ImageFluid from '../../legacy/components/base/ImageFluid';
import FluidImageWrapper from '../../legacy/components/base/FluidImageWrapper';
import { Tag } from './type';
import { getKey } from '../../legacy/helpers';
import { useI18next } from 'gatsby-plugin-react-i18next';

// ********************************************************************************
type Props = {
  height: number;
  slug: string;
  title: string;
  image: any;
  content: string;
  tags: Tag[];
};
export const ExperienceCard: React.FC<Props> = ({ height = 300, slug, title, image, content, tags }) => {
  const { language: locale } = useI18next();

  return (
    <Box
      sx={{
        height,
        minHeight: 300,
        width: '100%',
        borderRadius: '12px',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Link to={slug}>
        <Box
          display="flex"
          width="100%"
          justifyContent="flex-start"
          alignItems="flex-end"
          color={'white'}
          sx={{ height: '100%', position: 'absolute', zIndex: 1 }}
          p="1em"
        >
          <Stack spacing={1}>
            <Box display="flex" gap={1}>
              {tags.map((tag) => (
                <Chip
                  key={tag.id}
                  label={getKey(tag, `title_${locale}`) ?? ''}
                  variant="filled"
                  color="primary"
                  size="small"
                />
              ))}
            </Box>
            <Typography variant="h4" sx={{ fontWeight: 700, fontSize: '1rem' }}>
              {title}
            </Typography>
            <Typography
              fontFamily="Gotham-Light"
              fontSize="14px"
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {content}
            </Typography>
          </Stack>
        </Box>

        <Box
          sx={{
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            position: 'absolute',
            background: 'linear-gradient(360deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 50%)',
          }}
        />
        <FluidImageWrapper>
          <ImageFluid fluid={image} />
        </FluidImageWrapper>
      </Link>
    </Box>
  );
};
